import { render } from "./PaymentChannelListPage.vue?vue&type=template&id=8fb4fae4&ts=true"
import script from "./PaymentChannelListPage.vue?vue&type=script&lang=ts"
export * from "./PaymentChannelListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__